import { useEffect, useRef } from 'react';
import { trackAnalyticsEvent } from '../Utils';

export const useTrackGameComplete = (challengeId: string, challengeName: string) => {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!hasTracked.current) {
      trackAnalyticsEvent({
        eventName: 'game_complete',
        eventProperties: {
          challengeId,
          challengeName,
        },
      });
      hasTracked.current = true;
    }
  }, [challengeId, challengeName]);
};
